var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPollsIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DFEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.75C13.5 8.08696 13.7634 7.45107 14.2322 6.98223C14.7011 6.51339 15.337 6.25 16 6.25C16.663 6.25 17.2989 6.51339 17.7678 6.98223C18.2366 7.45107 18.5 8.08696 18.5 8.75V21.25C18.5 21.913 18.2366 22.5489 17.7678 23.0178C17.2989 23.4866 16.663 23.75 16 23.75C15.337 23.75 14.7011 23.4866 14.2322 23.0178C13.7634 22.5489 13.5 21.913 13.5 21.25V8.75ZM7.25 16.25C7.25 15.587 7.51339 14.9511 7.98223 14.4822C8.45107 14.0134 9.08696 13.75 9.75 13.75C10.413 13.75 11.0489 14.0134 11.5178 14.4822C11.9866 14.9511 12.25 15.587 12.25 16.25V21.25C12.25 21.913 11.9866 22.5489 11.5178 23.0178C11.0489 23.4866 10.413 23.75 9.75 23.75C9.08696 23.75 8.45107 23.4866 7.98223 23.0178C7.51339 22.5489 7.25 21.913 7.25 21.25V16.25ZM19.75 13.75C19.75 13.087 20.0134 12.4511 20.4822 11.9822C20.9511 11.5134 21.587 11.25 22.25 11.25C22.913 11.25 23.5489 11.5134 24.0178 11.9822C24.4866 12.4511 24.75 13.087 24.75 13.75V21.25C24.75 21.913 24.4866 22.5489 24.0178 23.0178C23.5489 23.4866 22.913 23.75 22.25 23.75C21.587 23.75 20.9511 23.4866 20.4822 23.0178C20.0134 22.5489 19.75 21.913 19.75 21.25V13.75Z",
    fill: "#178EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollsIconBlue);
export default __webpack_public_path__ + "static/media/polls-icon-blue.53df58e129468c77e7fa55c1a545917b.svg";
export { ForwardRef as ReactComponent };